import {
  isImmersiLearn,
  isTheNextGenXR,
  isVirtuPaths,
  isXRLAb360,
} from "./isCreditCardProduct";
import { isMobioVr } from "./isMobioVr.utils";

export const getCreditCardProductLogo = () => {
  return isMobioVr
    ? "/images/header/mobiovrlogo.png"
    : isImmersiLearn
    ? "/images/header/immerse_logo.svg"
    : isXRLAb360
    ? "/images/header/xrlab360_logo.svg"
    : isTheNextGenXR
    ? "/images/header/thenextgenxr_logo.svg"
    : isVirtuPaths
    ? "/images/header/virtupaths_logo.svg"
    : "/images/header/logo.svg";
};
